import { render, staticRenderFns } from "./CounterCardComponent.vue?vue&type=template&id=07479682&scoped=true"
import script from "./CounterCardComponent.vue?vue&type=script&lang=js"
export * from "./CounterCardComponent.vue?vue&type=script&lang=js"
import style0 from "./CounterCardComponent.vue?vue&type=style&index=0&id=07479682&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07479682",
  null
  
)

export default component.exports